import { render } from "./PositionSwapModal.vue?vue&type=template&id=a2cd8f18"
import script from "./PositionSwapModal.vue?vue&type=script&lang=js"
export * from "./PositionSwapModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__